import {
  Component,
  ViewChild,
  TemplateRef,
  // Inject,
  Output,
  Input,
  EventEmitter,
} from "@angular/core";
import { TransferItem } from "ng-zorro-antd/transfer";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import {
  VAIconRegistryService,
  chevronDown,
  chevronUp,
} from "@va/core-library/icons";
import { ComparativeTickerModalComponent } from "../comparative-ticker-modal/comparative-ticker-modal.component";
import { NzModalService, NzModalRef } from "ng-zorro-antd/modal";
import { MatSnackBar, MatSnackBarRef } from "@angular/material/snack-bar";
import { CHART_TYPE_DATA } from "../constants";

@Component({
  selector: "app-comparative-chart-ticker-filter",
  templateUrl: "./comparative-chart-ticker-filter.component.html",
  styleUrls: ["./comparative-chart-ticker-filter.component.scss"],
})
export class ComparativeChartTickerFilterComponent {
  @Input() recentlyVisitedCompanies;
  @Input() watchlistData;
  @Input() industryMenuData;
  @Input() marketGeoData;
  @Input() suggestedPeers;
  @Input() headerTitle = "";
  @Input() pageType;
  @Input() compId;
  @Input() tickerSelectionType;
  @Input() tickers;
  @Input() customTickers;
  @Input() tickerIncludeAverageSelected;
  @Input() selectedChartType;
  @Output() initiateWatchlistFetch: EventEmitter<any> = new EventEmitter();
  @Output() updateChartState: EventEmitter<any> = new EventEmitter();
  @Output() updateUnsavedDataStatus: EventEmitter<any> = new EventEmitter();
  @Output() updateTickersFromEditModalStatus: EventEmitter<any> =
    new EventEmitter();
  @Output() updateTickerSelectionTypeStatus: EventEmitter<any> =
    new EventEmitter();

  list: TransferItem[] = [];
  disabled = false;
  visible: boolean = false;
  faInfoCircle = faInfoCircle;
  searchVal;
  selectVal;
  changeVal;
  tickerLimit = 500;
  tickersModal: NzModalRef;
  isUserSettingUpdateInProgress = false;
  //snackbar
  snackbarInfo: { message: string; type: string } = {
    message: "",
    type: "info",
  };
  snackBarRef: MatSnackBarRef<any>;
  snackbarMessage = "";
  selectedCustomTickerCount = 0;
  transferTitles = [
    "Select up to 10 companies",
    `Selected companies: ${this.selectedCustomTickerCount}`,
  ];
  customTickerCidList = [];
  selectedTickerRadio = "";
  initialList = [];
  includeAverage: boolean;
  applyButtonClicked: boolean = false;
  chartType = CHART_TYPE_DATA;

  constructor(
    private iconRegistry: VAIconRegistryService,
    private modalService: NzModalService,
    private snackBar: MatSnackBar,
  ) {
    this.iconRegistry.registerIcons([chevronDown, chevronUp]);
  }

  @ViewChild("successTemplate") successTemplate: TemplateRef<any>;
  @ViewChild("failureTemplate") failureTemplate: TemplateRef<any>;
  @ViewChild("infoTemplate") infoTemplate: TemplateRef<any>;

  ngOnInit(): void {}

  ngOnChanges(changes) {
    if (
      (changes.tickers &&
        changes.tickers.currentValue &&
        changes.tickers.currentValue !== changes.tickers.previousValue) ||
      (changes.customTickers &&
        changes.customTickers.currentValue &&
        changes.customTickers.currentValue !==
          changes.customTickers.previousValue)
    ) {
      this.setupTickerSelectionBox();
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filterOption(inputValue: string, item: any): boolean {
    return item.title.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
  }

  editTickers() {
    this.tickersModal = this.modalService.create({
      nzTitle: "Edit Tickers",
      nzContent: ComparativeTickerModalComponent,
      nzMaskClosable: false,
      nzComponentParams: {
        addRowTableData: this.tickers, //this.addRowTableData,
        suggestedPeers: {
          watchername: "Suggested Peers",
          company_info: this.suggestedPeers,
        },
        recentlyVisitedCompanies: {
          company_info: this.recentlyVisitedCompanies
            ? [...this.recentlyVisitedCompanies]
            : [],
          watchername: "Recently viewed (up to 30)",
        },
        industryData: this.industryMenuData ? [...this.industryMenuData] : [],
        watchlistData: this.watchlistData ? [...this.watchlistData] : [],
        watchlistName: this.headerTitle,
        marketGeoData: this.marketGeoData
          ? { ...this.marketGeoData }
          : undefined,
        maxHeight: "340px",
        mpt: 1, //this.mpt,
        type: "edit",
        maxTickers: this.tickerLimit,
      },
      nzWrapClassName: "comps-modal-container vertical-center-modal",
      // nzWrapClassName: "watchlist-modal-container search-and-add-modal-container",
      nzFooter: [
        {
          label: "Cancel",
          type: "default",
          onClick: (): void => {
            this.tickersModal.destroy();
          },
        },
        {
          label: "Update",
          type: "primary",
          class: "update-btn",
          onClick: (data): void => {
            this.tickersModal.destroy();
            this.updateTickersFromEditModalStatus.emit(data);
          },
          disabled: (data) => {
            return (
              data["watchlistError"] !== "" ||
              data["modalData"].length > this.tickerLimit ||
              data["modalData"].length === 0
            );
          },
        },
      ],
    });
  }

  showSnackBarToastMessage(info) {
    this.snackbarMessage = info.message;
    this.snackBarRef = this.getSnackbarRef(info.type);
  }

  getSnackbarRef(type) {
    const typeMap = {
      success: this.successTemplate,
      info: this.infoTemplate,
      failure: this.failureTemplate,
    };
    if (typeMap[type]) {
      return this.snackBar.openFromTemplate(typeMap[type], {
        panelClass: type,
        duration: 5000,
        verticalPosition: "top",
      });
    }
    return undefined;
  }

  search(ret: {}): void {
    this.searchVal = ret;
  }

  select(ret: {}): void {
    this.selectVal = ret;
  }

  popOverChange() {
    if (this.visible) {
      this.applyButtonClicked = false;
    } else if (!this.visible && !this.applyButtonClicked) {
      this.setupTickerSelectionBox();
    }
  }

  setupTickerSelectionBox() {
    this.selectedTickerRadio = this.tickerSelectionType;
    this.customTickerCidList = this.customTickers;
    this.includeAverage = this.tickerIncludeAverageSelected;
    this.list = [];
    this.tickers.forEach((ticker) => {
      this.list.push({
        key: ticker.companyid || ticker.cid,
        title: `${ticker.ticker}: ${ticker.full_name}`,
        direction: this.customTickerCidList.includes(
          ticker.companyid || ticker.cid,
        )
          ? "right"
          : "left",
      });
    });
    this.initialList = JSON.parse(JSON.stringify(this.list));
    this.selectedCustomTickerCount = this.customTickerCidList.length;
    this.transferTitles[1] = `Selected companies: ${this.selectedCustomTickerCount}`;
  }

  onTransferClick(): void {
    this.customTickerCidList = this.list
      .filter((ticker) => {
        return ticker.direction === "right";
      })
      .map((filteredTicker) => filteredTicker.key);
    this.selectedCustomTickerCount = this.customTickerCidList.length;
    this.transferTitles[1] = `Selected companies: ${this.selectedCustomTickerCount}`;
  }

  handleApplyClick() {
    this.applyButtonClicked = true;
    if (this.selectedTickerRadio === "top_ten") {
      this.list = this.initialList;
      this.selectedCustomTickerCount = this.customTickers.length;
      this.customTickerCidList = this.customTickers;
      this.transferTitles[1] = `Selected companies: ${this.selectedCustomTickerCount}`;
    }
    this.updateTickerSelectionTypeStatus.emit({
      tickerSelectionType: this.selectedTickerRadio,
      customTickers:
        this.selectedTickerRadio === "custom"
          ? this.customTickerCidList
          : this.customTickers,
      includeAverage: this.includeAverage,
    });
    this.visible = false;
  }

  handleTickerDropdownFilterClick() {
    this.visible = !this.visible;
  }
}
